var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossRounded = function SvgCrossRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 62c17.12 0 31-13.88 31-31C62 13.88 48.12 0 31 0 13.88 0 0 13.88 0 31c0 17.12 13.88 31 31 31ZM19.232 22.768 27.465 31l-8.233 8.232 3.536 3.536L31 34.536l8.232 8.232 3.536-3.536L34.535 31l8.233-8.232-3.536-3.536L31 27.465l-8.232-8.233-3.536 3.536Z",
    fill: "#EBE8ED"
  })));
};
export default SvgCrossRounded;